import { render } from "./AdminCampaigns.vue?vue&type=template&id=37e38a7c"
import script from "./AdminCampaigns.vue?vue&type=script&lang=js"
export * from "./AdminCampaigns.vue?vue&type=script&lang=js"

import "./AdminCampaigns.vue?vue&type=style&index=0&id=37e38a7c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__